
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import Button from '@mui/material/Button';
import Sidebar from './Sidebar'; // Import the new component
import '../Static/PHPStatic/Navigation.css'; // Import the CSS file

const customButtonStyle = {
  textTransform: 'capitalize',
  fontVariant: 'lowercase',
  borderColor: 'white',
  color: 'white'
};

const Navigation = ({ children }) => {
  const [sidebarr, setSidebarr] = useState(false);
  const navigate = useNavigate();
  const toggleSidebar = () => {
    setSidebarr(!sidebarr);
  };
  const userData = sessionStorage.getItem('user');
  // console.log(userData);
  useEffect(() => {
    if (userData === null) {
      navigate('/');
      window.location.reload();
    }
  }, [userData]);
  const handleLogout = () => {
    sessionStorage.removeItem('user');
    navigate('/');
    window.location.reload();
  };

  return (
    <IconContext.Provider value={{ color: '#fff' }}>
      <div className={`content-wrapper ${sidebarr ? '' : 'no-sidebar'}`}>
        <div className="nav">
          <Link className="nav-icon" to="#">
            <FaIcons.FaBars onClick={toggleSidebar} />
          </Link>
          <h2 className="nav-title">Uniform Manufacture System</h2>
          {/* <div className="nav-btn">
            <Button variant="outlined" sx={{ mr: 2 }} size="small" style={customButtonStyle}>Honesty</Button>
            <Button variant="outlined" sx={{ mr: 2 }} size="small" style={customButtonStyle}>Ticket</Button>
            <Button variant="outlined" sx={{ mr: 2 }} size="small" style={customButtonStyle}>Reply</Button>
            <Button variant="outlined" sx={{ mr: 2 }} size="small" style={customButtonStyle}>Logout</Button>
          </div> */}
          <div className="nav-btn">
            <Button variant="outlined" sx={{ mr: 2 }} size="small" style={customButtonStyle} onClick={handleLogout}>Logout</Button>
          </div>
        </div>
        <Sidebar sidebarr={sidebarr} />

        <div style={{ margin: '0.5%' }}>
          {children}
        </div>
      </div>
    </IconContext.Provider>
  );
};

export default Navigation;
